/*
 * The document lists out all active modules / add-ons for the system
 **/
const _modules = {
  // General
  business_entities: true,
  business_entity_notices: true,
  document_types: true,
  email_logs: true,
  external_documents: true,
  regions: true,
  staffs: true,
  users: true,
  e_signs: true,

  // Report
  trading_report: true,
  account_report: true,
  inventory_management_report: true,
  human_resource_management_report: true,
  project_management_report: true,

  // [Trading] module
  clients: true,
  partners: true,
  suppliers: true,
  contact_people: true,
  products: true,
  product_lines: true,
  material_categories: true,
  purchase_orders: true,
  sales_orders: true,
  sales_quotations: true,
  sales_invoices: true,
  sales_receipts: true,
  contracts: true,
  returns: true,
  commissions: true,
  terms_and_conditions: true,
  sales_invoices_chart: true,

  // [Account] module
  ledgers: true,
  vouchers: true,
  banks: true,
  credit_cards: true,
  debit_cards: true,
  taxes: true,
  account_settings: true,

  // [Inventory Management]
  product_stocks: true,
  inventory_settings: true,

  // [HRM] module
  attendance_records: true,
  benefits: true,
  applications: true,
  expenses: true,
  salary: true,
  salary_reports: true,
  mpf_reports: true,
  warning_letters: true,
  commendatory_letters: true,
  promotion_letters: true,
  reference_letters: true,
  staff_evaluations: true,
  shifts: true,

  // [Project Management]
  equipments: true,
  projects: true,
  project_types: true,

  //[Job]
  job: true,
  job_record: true,
  job_progress: true,

  //[Meeting]
  meeting: true,
  meeting_minute: true,

  //[Questionnaires]
  questionnaires: true,
  questionnaire_reports: true,
  questionnaires_chart: true,
}

export default _modules
